<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Keyword</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <keyword-form :data="data"></keyword-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import KeywordForm from './KeywordForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'KeywordDialog',
  data() {
    return {
      data: {
        name: '',
        order: 0
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'keywords', 'item'],
  components: {
    KeywordForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting keyword data for id ', this.item.id)
      axios
        .get('api/admin/keywords/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new keywords')
      axios
        .post('api/admin/keywords/create', {
          name: this.data.name,
          order: this.data.order
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating keyword data for id ', this.item.id)
      axios
        .put(`api/admin/keywords/${this.item.id}`, {
          name: this.data.name,
          order: this.data.order
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        name: '',
        order: 0
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
